import axios from 'axios';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

export const analyzeSourcesBias = async (sources) => {
    try {
        const response = await axios.post(`${BACKEND_API_URL}/analyze-bias`, { sources });
        return response.data;
    } catch (error) {
        console.error('Error analyzing sources bias:', error);
        throw error;
    }
};